/*
 * XYNE Redesign — Subscribe state controller
 *
 * Single sitewide source of truth for "this person is already subscribed".
 * When true, hides every newsletter/signup surface across the site:
 *   - Footer newsletter form
 *   - Homepage redesign-newsletter section
 *   - Welcome popup
 *   - Any future signup surfaces tagged with the same root classes
 *
 * Sources of truth (any one is sufficient):
 *   1. Cookie `xyne_subscribed=1` — set by this script when a signup form
 *      success is detected, and persists 1 year per-browser/device.
 *   2. `<body data-rd-customer-marketing="true">` — set server-side via
 *      Liquid from `customer.accepts_marketing`. Covers signed-in customers
 *      across devices (Shopify customer record carries marketing consent).
 *   3. A success marker on the page — server-rendered Shopify customer-form
 *      success states get a `data-rd-subscribe-success` attribute. On page
 *      load we scan for that and immediately set the cookie.
 *
 * When subscribed:
 *   - `<html>` and `<body>` get class `rd-already-subscribed`
 *   - CSS rule (in redesign-base.css) hides every newsletter surface
 *
 * Public API:
 *   - `window.rdMarkSubscribed()` — call from any custom submit handler on
 *     successful signup (e.g. welcome popup AJAX submit).
 *   - `window.rdIsSubscribed()` — read current state.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'xyne_subscribed';
  var COOKIE_DAYS = 365;

  function getCookie(name) {
    var match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? match[2] : '';
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie =
      name + '=' + value + ';expires=' + expires + ';path=/;SameSite=Lax';
  }

  function isSubscribed() {
    if (getCookie(COOKIE_NAME) === '1') return true;
    var body = document.body;
    if (!body) return false;
    return body.getAttribute('data-rd-customer-marketing') === 'true';
  }

  function applyState() {
    if (!document.body) return;
    if (isSubscribed()) {
      document.documentElement.classList.add('rd-already-subscribed');
      document.body.classList.add('rd-already-subscribed');
    }
  }

  function markSubscribed() {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    applyState();
  }

  function scanForSuccessMarkers() {
    if (document.querySelector('[data-rd-subscribe-success]')) {
      markSubscribed();
    }
  }

  function init() {
    applyState();
    scanForSuccessMarkers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for JS-driven submit flows (welcome popup AJAX, etc.)
  window.rdMarkSubscribed = markSubscribed;
  window.rdIsSubscribed = isSubscribed;
})();
